module.exports = __webpack_public_path__ + "media/img/Landing_Page/Scholarships2u-Virtual-Scholarship-Fair-2020-bg-4c06b7880db4ba6b1a5b8ec1fb8bf61d.jpg";